export enum LocaleCode {
    DE_CH = 'de-CH',
    FR_CH = 'fr-CH',
    // IT_CH = 'it-CH',
}
